import { Button, Divider, message, Spin, Table, Tabs } from "antd";
import React, { useEffect, useState } from "react";

import { useGetPatientInsuranceEligibility } from "../TreatmentPlans/component/useGetPatientInsuranceEligibility";
// The full policy form (carrier, member, plan details). The board's own copy
// had no carrier field, so the server refused every save — silently.
import PatientPolicyInfoFormModal from "../TreatmentPlans/component/PatientPolicyInfoFormModal";
import PredeterminationModal from "./predeterminatonModal/PredeterminationModal";
import Eligibility2FAFormModal from "./components/Eligibility2FAFormModal";
import EligibilityDataModal from "./components/EligibilityDataModal";
import { activityStatusLabelColor } from "./statusLabelColor";
import BreakdownModal from "./breakdownModal/BreakdownModal";

import { activityTimelineData, treatmentTableData } from "./testData";
import { controller } from "./controller";

import magic from "../../assets/icons/hugeicons--ai-magic.svg";
import date from "../../assets/icons/calendar-purple.svg";
import arrowDown from "../../assets/icons/arrow-down.svg";
import close from "../../assets/icons/close-circle.svg";
import clock from "../../assets/icons/clock.svg";
import call from "../../assets/icons/call.png";
import sms from "../../assets/icons/sms3.svg";

export default function PatientDetails({ modalRef, setClickedPatientId, clickedPatientId }) {
  const [showPatientInsuranceFormModal, setShowPatientInsuranceFormModal] = useState(false);
  const [showEligibility2FAFormModal, setShowEligibility2FAFormModal] = useState(false);
  const [showInsuranceBreakdownModal, setShowInsuranceBreakdownModal] = useState(false);
  const [showPredeterminationModal, setShowPredeterminationModal] = useState(false);
  const [editPatientInsuranceData, setEditPatientInsuranceData] = useState(false);
  const [showEligibilityDataModal, setShowEligibilityDataModal] = useState(false);
  const [isGettingPatientDetails, setIsGettingPatientDetails] = useState(true);
  const [cancelProcess, setCancelProcess] = useState(false);
  const [runningAgent, setRunningAgent] = useState(undefined);
  const [patientDetailsInfo, setPatientDetailsInfo] = useState(null);

  const {
    checkPatientInsuranceEligibility,
    isLoading: isGettingPatientInsuranceEligibility,
    eligibilityData: eligibilityAgentData,
    eligibilityAgentToken,
  } = useGetPatientInsuranceEligibility(
    patientDetailsInfo && patientDetailsInfo.id,
    setShowPatientInsuranceFormModal,
    setShowEligibility2FAFormModal,
    cancelProcess,
    {},
  );

  const {
    checkPatientInsuranceEligibility: checkPatientInsuranceBreakdown,
    isLoading: isAgentGettingBreakdownData,
    eligibilityData: breakdownAgentData,
    eligibilityAgentToken: breakdownAgentToken,
  } = useGetPatientInsuranceEligibility(
    patientDetailsInfo && patientDetailsInfo.id,
    setShowPatientInsuranceFormModal,
    setShowEligibility2FAFormModal,
    cancelProcess,
    {},
  );

  const {
    checkPatientInsuranceEligibility: checkPatientInsurancePredeterminaton,
    isLoading: isAgentGettingPredeterminationData,
    eligibilityData: predeterminationData,
    eligibilityAgentToken: predeterminationAgentToken,
    predeterminationBatchID,
  } = useGetPatientInsuranceEligibility(
    patientDetailsInfo && patientDetailsInfo.id,
    setShowPatientInsuranceFormModal,
    setShowEligibility2FAFormModal,
    cancelProcess,
    {},
  );

  console.log(patientDetailsInfo);

  useEffect(() => {
    console.log("clickedPatientId", clickedPatientId);
    if (!clickedPatientId) return;

    const getPatientDetails = async (patientId) => {
      try {
        setIsGettingPatientDetails(true);
        const response = await controller.getPatientDetails(patientId);
        console.log("patientDetailsInfo", response);
        setPatientDetailsInfo(response.json);
      } catch (err) {
        message.error("Something went wrong while getting patient details");
        console.error(err);
      } finally {
        setIsGettingPatientDetails(false);
      }
    };
    getPatientDetails(clickedPatientId);
  }, [clickedPatientId]);

  useEffect(
    function () {
      if (!runningAgent) return;

      if (runningAgent === "eligibility") checkPatientInsuranceEligibility();
      if (runningAgent === "breakdown") checkPatientInsuranceBreakdown();
      if (runningAgent === "predetermination") checkPatientInsurancePredeterminaton();

      setCancelProcess(false);
    },
    [runningAgent]
  );

  // Show the eligibility data modal when the eligibility data is provided
  useEffect(() => {
    if (eligibilityAgentData === undefined) return;
    setShowEligibilityDataModal(true);
  }, [eligibilityAgentData]);

  // Show breakdown modal
  useEffect(
    function () {
      if (breakdownAgentData === undefined) return;
      setShowInsuranceBreakdownModal(true);
    },
    [breakdownAgentData]
  );

  // Show predetermination modal
  useEffect(
    function () {
      if (predeterminationData === undefined) return;
      setShowPredeterminationModal(true);
    },
    [predeterminationData]
  );

  const treatmentColumns = [
    {
      title: "",
      key: "icon",
      render: () => <img src={arrowDown} alt="arrow-down" />,
    },
    {
      title: "Treatment",
      dataIndex: "treatment_name",
      key: "treatment_name",
    },
    {
      title: "Treatment",
      dataIndex: "treatment_name",
      key: "treatment_name",
    },
    {
      title: "Treatment",
      dataIndex: "treatment_name",
      key: "treatment_name",
    },
  ];

  const activityTimelineColumns = [
    {
      title: "",
      key: "icon",
      render: () => <img src={magic} alt="magic" />,
    },
    {
      title: "Activity",
      dataIndex: "activity",
      key: "activity",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (text, record) => (text !== "" ? `${text} - ${record.time}` : "-"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render(text) {
        const { statusColor, statusBackgroundColor } = activityStatusLabelColor(text);
        return (
          <span
            style={{
              backgroundColor: statusBackgroundColor,
              color: statusColor,
              padding: "3px 10px",
              borderRadius: 100,
              fontSize: 12,
              textTransform: "capitalize",
            }}
          >
            {text}
          </span>
        );
      },
    },
  ];

  const treatmentTabs = [
    {
      key: "1",
      label: "Option 1",
      children: <Table columns={treatmentColumns} dataSource={treatmentTableData} pagination={false} />,
    },
    {
      key: "2",
      label: "Option 2",
      children: <Table columns={treatmentColumns} dataSource={treatmentTableData} pagination={false} />,
    },
  ];

  function handleRedirectToTreatmentDetails() {
    localStorage.setItem("patient-from-patient-board-for-treatment", JSON.stringify(patientDetailsInfo));
    window.location.href = "#/treatment-plans";
  }

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "110%",
        backgroundColor: "rgba(0,0,0,0.15)",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        padding: 3,
        zIndex: 10,
        borderRadius: 10,
        margin: "6px 0",
      }}
    >
      <div
        ref={modalRef}
        style={{
          width: "50%",
          height: "100%",
          backgroundColor: "white",
          borderRadius: 10,
          padding: "15px 14px",
          boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.15)",
          overflowY: "auto",
        }}
        className="custom-scroll"
      >
        {isGettingPatientDetails ? (
          <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Spin size="large" />
          </div>
        ) : (
          <>
            {/* Title and close  */}
            <div
              style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10, padding: "10px 10px 0", justifyContent: "space-between" }}
            >
              <p style={{ fontSize: 18, fontWeight: "bold", marginBottom: 0 }}>
                {patientDetailsInfo.first_name} {patientDetailsInfo.last_name}'s Details
              </p>

              <div className="audience-modal-close-btn-hover" onClick={() => setClickedPatientId(null)}>
                <img src={close} alt="close" />
              </div>
            </div>

            {/* status  */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 10px" }}>
              <span
                style={{
                  backgroundColor: "#EEEDFA",
                  color: "#6B43B5",
                  padding: "3px 10px",
                  borderRadius: 100,
                  fontSize: 12,
                }}
              >
                List Name
              </span>

              <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                <span style={{ fontSize: 16 }}>Current Status: </span>
                <span
                  style={{
                    backgroundColor: "#97979726",
                    color: "#848696",
                    padding: "3px 10px",
                    borderRadius: 100,
                    fontSize: 12,
                    textTransform: "capitalize",
                  }}
                >
                  processing
                </span>
              </div>
            </div>

            <div style={{ padding: "0 10px" }}>
              <Divider type="horizontal" style={{ backgroundColor: "#C9C1F1", margin: "25px 0", width: "90%" }} />
            </div>

            {/* Phone and mail  */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 30, padding: "0 10px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                <img src={call} alt="phone" style={{ width: 20 }} />
                <span style={{ fontSize: 16 }}>{patientDetailsInfo.phone}</span>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                <img src={sms} alt="phone" style={{ width: 20 }} />
                <span style={{ fontSize: 16 }}>{patientDetailsInfo.email}</span>
              </div>
            </div>

            {/* Agent actions */}
            <div style={{ marginBottom: 30, padding: "0 10px" }}>
              <p style={{ fontSize: 18 }}>Quick Actions</p>

              <div style={{ display: "flex", alignItems: "center", gap: 15, justifyContent: "space-between", width: "100%" }}>
                <Button
                  onClick={() => setRunningAgent("eligibility")}
                  style={{ border: "1px solid #6B43B5", width: "100%", color: "#6B43B5", borderRadius: 10, fontSize: 16, padding: "30px 0" }}
                  loading={isGettingPatientInsuranceEligibility}
                >
                  Insurance Eligbiility
                </Button>

                <Button
                  onClick={() => setRunningAgent("breakdown")}
                  style={{ border: "1px solid #6B43B5", width: "100%", color: "#6B43B5", borderRadius: 10, fontSize: 16, padding: "30px 0" }}
                  loading={isAgentGettingBreakdownData}
                >
                  Breakdown
                </Button>

                <Button
                  onClick={() => setRunningAgent("predetermination")}
                  style={{ border: "1px solid #6B43B5", width: "100%", color: "#6B43B5", borderRadius: 10, fontSize: 16, padding: "30px 0" }}
                  loading={isAgentGettingPredeterminationData}
                >
                  Predetermination
                </Button>
              </div>
            </div>

            {/* Quick Actions */}
            <div style={{ marginBottom: 30, padding: "0 10px" }}>
              <p style={{ fontSize: 18 }}>Quick Actions</p>

              <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gridTemplateRows: "repeat(2, 1fr)", gap: 15 }}>
                <Button style={{ border: "1px solid #6B43B5", color: "#6B43B5", borderRadius: 10, fontSize: 16, padding: "30px 0" }}>
                  Book Apointment
                </Button>

                <Button
                  style={{ border: "1px solid #6B43B5", color: "#6B43B5", borderRadius: 10, fontSize: 16, padding: "30px 0" }}
                  onClick={handleRedirectToTreatmentDetails}
                >
                  Edit Treatment Plan
                </Button>

                <Button style={{ border: "1px solid #6B43B5", color: "#6B43B5", borderRadius: 10, fontSize: 16, padding: "30px 0" }}>
                  Payment Details
                </Button>

                <Button style={{ border: "1px solid #6B43B5", color: "#6B43B5", borderRadius: 10, fontSize: 16, padding: "30px 0" }}>
                  View Patient
                </Button>
              </div>
            </div>

            {/* Activity Timeline */}
            <div style={{ marginBottom: 30, padding: "0 10px" }}>
              <p style={{ fontSize: 18 }}>Activity Timeline</p>

              <Table dataSource={activityTimelineData} columns={activityTimelineColumns} pagination={false} />
            </div>

            {/* Treatments */}
            <div style={{ marginBottom: 20 }}>
              <p style={{ fontSize: 18, padding: "0 10px" }}>Treatments</p>

              <Tabs type="card" items={treatmentTabs} className="customize-treatment-tabs" tabBarGutter={10} />
            </div>

            {/* Fotter */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 10px 10px 10px" }}>
              <span style={{ color: "#848696", fontSize: 16 }}>Last Moved:</span>

              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                  <img src={date} alt="date" style={{ width: 20 }} />
                  <span style={{ color: "#848696", fontSize: 16 }}>2024/12/12</span>
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                  <img src={clock} alt="date" style={{ width: 20 }} />
                  <span style={{ color: "#848696", fontSize: 16 }}>From: List name</span>
                </div>
              </div>
            </div>

            {/* Eligibility Form Modal */}
            <PatientPolicyInfoFormModal
              setShowPatientInsuranceFormModal={setShowPatientInsuranceFormModal}
              checkPatientInsuranceEligibility={checkPatientInsuranceEligibility}
              showPatientInsuranceFormModal={showPatientInsuranceFormModal}
              setEditPatientInsuranceData={setEditPatientInsuranceData}
              editPatientInsuranceData={editPatientInsuranceData}
              patientID={patientDetailsInfo && patientDetailsInfo.id}
              patient={patientDetailsInfo}
              setCancelProcess={setCancelProcess}
            />

            {/* 2FA Form Modal */}
            <Eligibility2FAFormModal
              showEligibility2FAFormModal={showEligibility2FAFormModal}
              setShowEligibility2FAFormModal={setShowEligibility2FAFormModal}
              eligibilityAgentToken={eligibilityAgentToken}
              setCancelProcess={setCancelProcess}
              type={runningAgent}
            />

            {/* Show Eligiblity Data Modal */}
            <EligibilityDataModal
              showEligibilityDataModal={showEligibilityDataModal}
              setShowEligibilityDataModal={setShowEligibilityDataModal}
              eligibilityData={eligibilityAgentData}
            />

            {/* Breakdown Modal */}
            <BreakdownModal
              setShowInsuranceBreakdownModal={setShowInsuranceBreakdownModal}
              showInsuranceBreakdownModal={showInsuranceBreakdownModal}
              breakdown={breakdownAgentData}
              patient={patientDetailsInfo}
            />

            {/* Predetermination */}
            <PredeterminationModal
              // setPredeterminationTreatmentID={setPredeterminationTreatmentID}
              setShowPredeterminationModal={setShowPredeterminationModal}
              predeterminationData={predeterminationData}
              // predeterminationTreatmentID={predeterminationTreatmentID}
              showPredeterminationModal={showPredeterminationModal}
              patient={patientDetailsInfo}
            />
          </>
        )}
      </div>
    </div>
  );
}
